import { inject, injectable } from 'inversify';

import { User } from '@project44/ui-utils';
import { DtoBase, TenantModels } from '@project44-models/iam-gateway';

import { AxiosDelegationStrategyEnum } from '../../../../shared/core/domain/enums';
import { ParametersValueObject } from '../../../../shared/core/domain/ParameterValueObject';
import { ValueObject } from '../../../../shared/core/domain/ValueObject';
import { CommandUseCase } from '../../../shared/domain/UseCase';
import {
  TenantQueryPayload,
  TenantQueryResponse,
} from '../../domain/interfaces';
import { TenantServiceClientAdapter } from '../../infrastructure/adapters/TenantServiceClientAdapter';

@injectable()
export class TenantQueryUseCase extends CommandUseCase<
  { tenantQueryDto: DtoBase<TenantModels.TenantQueryViewModel> },
  TenantQueryResponse<TenantQueryPayload['axiosDelegationStrategy']>
> {
  constructor(
    @inject(TenantServiceClientAdapter)
    private readonly tenantRepository: TenantServiceClientAdapter,
  ) {
    super();
  }

  public async execute(
    user: User,
    payload: ParametersValueObject<{
      tenantQueryDto: DtoBase<TenantModels.TenantQueryViewModel>;
    }>,
  ): Promise<ValueObject<DtoBase<TenantModels.TenantQueryResultsViewModel>>> {
    this.validateAnyOfPermissions(user, [
      'system-admin:auth:switch-to-any-tenant',
    ]);

    return this.tenantRepository.query<AxiosDelegationStrategyEnum.EXECUTABLE>(
      ParametersValueObject.create({
        tenantQueryDto: payload.parameters.tenantQueryDto,
        axiosDelegationStrategy: AxiosDelegationStrategyEnum.EXECUTABLE,
      }),
    );
  }
}
